import React from 'react';
import {EyeIcon, Menu, MoreIcon, ScreenshareIcon, SendIcon} from '@fluentui/react-northstar';
import languageObject from "../../translations";
import {IMessageState} from "../../Interfaces/Message";
import {IDraftMessageSummary} from "../../Interfaces/IDraftMessageSummary";
import {ISentMessageSummary} from "../../Interfaces/ISentMessageSummary";
import {duplicateDraftNotification, resendNotificationToUnread} from 'apis/messageListApi';

export interface OverflowProps {
    message: IDraftMessageSummary | ISentMessageSummary;
    styles?: object;
    selectMessage?: any;
    getMessagesList?: any;
    getDraftMessagesList?: any;
    channelId: string;
    upnContext: string;
    showStatusDialog: (id: string) => void;
    onDuplicateMessage: () => void;
    onResendMessage: () => void;
}

export interface OverflowState {
    menuOpen: boolean;
}

class Overflow extends React.Component<OverflowProps, OverflowState> {
    constructor(props: OverflowProps) {
        super(props);
        this.state = {menuOpen: false};
    }

    private duplicateMessage = async (id: string) => {
        try {
            await duplicateDraftNotification(id);
            this.props.onDuplicateMessage();
        } catch (error) {
            return error;
        }
    }

    private resendToUnread = async (id: string) => {
        try {
            await resendNotificationToUnread(id);
            this.props.onResendMessage();
        } catch (error) {
            return error;
        }
    }

    render(): JSX.Element | null {
        if ("state" in this.props.message && this.props.message.state !== IMessageState.Sent) return null;

        const sentCount = (this.props.message as ISentMessageSummary).numberOfSuccess;
        const viewsCount = (this.props.message as ISentMessageSummary).numberOfViews;
        const canResendToUnread = sentCount > 0 && viewsCount < sentCount;

        const items = [
            {
                key: 'more',
                icon: <MoreIcon className={"list-more-icon"} outline={true}/>,
                menuOpen: this.state.menuOpen,
                active: this.state.menuOpen,
                indicator: false,
                menu: {
                    items: [
                        {
                            key: 'status',
                            icon: <EyeIcon styles={{marginBottom: "2px"}} outline/>,
                            content: languageObject.translate("ViewDetails"),
                            onClick: (event: React.SyntheticEvent) => {
                                event.stopPropagation();
                                this.props.showStatusDialog(this.props.message.id)
                            }
                        },
                        ...(canResendToUnread ? [{
                            key: 'resend-unread',
                            icon: <SendIcon outline/>,
                            content: languageObject.translate("ResendToUnread") + ` (${sentCount - viewsCount})`,
                            onClick: (event: React.SyntheticEvent) => {
                                event.stopPropagation();
                                this.setState({menuOpen: false});
                                this.resendToUnread(this.props.message.id).then();
                            }
                        }] : []),
                        {
                            key: 'duplicate',
                            icon: <ScreenshareIcon outline/>,
                            content: languageObject.translate("Duplicate"),
                            onClick: (event: React.SyntheticEvent) => {
                                event.stopPropagation();
                                this.setState({menuOpen: false});
                                this.duplicateMessage(this.props.message.id).then();
                            }
                        }
                    ],
                },
                onMenuOpenChange: (e: any, {menuOpen}: any) => {
                    this.setState({
                        menuOpen: menuOpen
                    });
                },
            },
        ];

        return (
            <Menu className="menuContainer" iconOnly items={items} styles={this.props.styles}/>
        )
    }
}

export default Overflow;